import React, { useEffect, } from 'react';
import { Form, Row, Col, } from 'react-bootstrap';

import HabilitationService from 'services/habilitationsService';


const DemandeDPSLightStep1 = ({
    register,
    errors,
    setValue,
}) => {
    useEffect(() => {
        if(HabilitationService.habilitations)
        {
            setValue("orgaRepresentePar", HabilitationService.habilitations.nomClient + ' ' + HabilitationService.habilitations.prenomClient);
            setValue("orgaRepresenteParMail", HabilitationService.habilitations.mailClient);
            setValue("orgaRepresenteParTel", HabilitationService.habilitations.telClient);
        }
    },[]);

    return (<>
        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center><h5 className='text-primary mb-2'>Vos coordonnées</h5></center>
            <Row>
                <Col md="12">
                    <Form.Group className="mb-2">
                        <Form.Label>Votre structure, association, club, collectivité, ...</Form.Label>
                        <Form.Control type="text" name="orgaRaisonSociale" id="orgaRaisonSociale" {...register("orgaRaisonSociale")} isInvalid={!!errors.orgaRaisonSociale}/>
                        <small className="text-danger">{errors.orgaRaisonSociale?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Votre Nom/Prénom</Form.Label>
                        <Form.Control type="text" name="orgaRepresentePar" id="orgaRepresentePar" {...register("orgaRepresentePar")} disabled={HabilitationService.habilitations ?  true : false} isInvalid={!!errors.orgaRepresentePar}/>
                        <small className="text-danger">{errors.orgaRepresentePar?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Votre fonction</Form.Label>
                        <Form.Control type="text" name="orgaRepresenteParFonction" id="orgaRepresenteParFonction" {...register("orgaRepresenteParFonction")}  isInvalid={!!errors.orgaRepresenteParFonction}/>
                        <small className="text-danger">{errors.orgaRepresenteParFonction?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Votre adresse email</Form.Label>
                        <Form.Control type="text" name="orgaRepresenteParMail" id="orgaRepresenteParMail" {...register("orgaRepresenteParMail")} disabled={HabilitationService.habilitations ?  true : false} isInvalid={!!errors.orgaRepresenteParMail}/>
                        <small className="text-danger">{errors.orgaRepresenteParMail?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Votre téléphone</Form.Label>
                        <Form.Control type="text" name="orgaRepresenteParTel" id="orgaRepresenteParTel" {...register("orgaRepresenteParTel")} disabled={HabilitationService.habilitations ?  true : false} isInvalid={!!errors.orgaRepresenteParTel}/>
                        <small className="text-danger">{errors.orgaRepresenteParTel?.message}</small>
                    </Form.Group>
                </Col>
            </Row>
        </div>
    </>);
};


DemandeDPSLightStep1.propTypes = {};

export default DemandeDPSLightStep1;